export const badgeClassByStatus = (s) => {
    const m = {
        pendiente: "secondary",   // gris (esperando confirmación)
        preparando: "warning",    // amarillo (en cocina)
        enviado: "info",          // azul claro (en camino)
        entregado: "success",     // verde (finalizado)
        cancelado: "danger",      // rojo (cancelado por cliente/restaurante)
    };
    return m[s] || "secondary";
};

export const badgeClassByPaymentStatus = (s) => {
    const m = {
        pendiente: "warning",    // amarillo (esperando pago)
        pagado: "success",       // verde (pagado con éxito)
        cancelado: "danger",     // rojo (cancelación del pago)
        abandonado: "secondary", // gris (cliente no pagó/abandonó)
    };
    return m[s] || "secondary";
};